import { buildModelManager } from "../builder.js";
const DefaultProfileSelection = {
  __typename: true,
  id: true,
  accreditations: true,
  address: true,
  addressCity: true,
  addressLine1: true,
  addressLine2: true,
  addressPostcode: true,
  addressRegion: true,
  aiCreditsBundleBalance: true,
  aiCreditsBundleResetAt: true,
  aiCreditsLastSpendAt: true,
  aiCreditsLifetimeSpent: true,
  aiCreditsTopupBalance: true,
  aiCreditsTrialGranted: true,
  allowCustomerCounterProposals: true,
  allowSampleData: true,
  autoChaseEnabled: true,
  autoPencilOnQuoteSend: true,
  autoReleaseExpiredTentatives: true,
  bookingPageEnabled: true,
  bookingShareToken: true,
  bookingShowBio: true,
  bookingShowCategories: true,
  bookingShowEmail: true,
  bookingShowPhone: true,
  bookingShowPhotos: true,
  bookingShowServices: true,
  bufferBetweenBookingsMinutes: true,
  businessEmail: true,
  businessLogo: { url: true, mimeType: true, fileName: true },
  businessLogoUrl: true,
  businessName: true,
  businessType: true,
  cisRole: true,
  commissionRateBasis: true,
  commissionRateNote: true,
  commissionRateOverride: true,
  compTier: true,
  companyNumber: true,
  confirmedOverlapPolicy: true,
  country: true,
  createdAt: true,
  currency: true,
  defaultDurationMinutes: true,
  defaultTaxCode: true,
  directoryShowEmail: true,
  directoryShowPhone: true,
  isPlatformOwner: true,
  locale: true,
  maxAdvanceWeeks: true,
  minNoticeHours: true,
  paywallExempt: true,
  phone: true,
  publicBio: true,
  publicCoveragePostcode: true,
  publicCoverageRadiusMiles: true,
  publicH3Res7: true,
  publicLat: true,
  publicListed: true,
  publicLng: true,
  publicSlug: true,
  quickbooksAccessToken: true,
  quickbooksConnectedAt: true,
  quickbooksRealmId: true,
  quickbooksRefreshToken: true,
  referralCode: true,
  schedulingMode: true,
  showPencilledOnPublic: true,
  stripeAccountBusinessType: true,
  stripeAccountChargesEnabled: true,
  stripeAccountDetailsSubmitted: true,
  stripeAccountId: true,
  stripeAccountMcc: true,
  stripeBankBrand: true,
  stripeBankLast4: true,
  taxAutomationEnabled: true,
  taxRegion: true,
  tentativePromotionLeadDays: true,
  timezone: true,
  tradeType: true,
  updatedAt: true,
  userId: true,
  utr: true,
  uuid: true,
  vatNumber: true,
  vatRegistered: true,
  whatsappBusinessId: true,
  whatsappDisplayName: true,
  whatsappPhoneNumberId: true,
  whatsappSystemUserToken: true,
  whatsappWabaId: true,
  workingHours: true,
  xeroAccessToken: true,
  xeroConnectedAt: true,
  xeroRefreshToken: true,
  xeroTenantId: true,
  xeroTenantName: true
};
const modelApiIdentifier = "profile";
const pluralModelApiIdentifier = "profiles";
;
;
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultProfileSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultProfileSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultProfileSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultProfileSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultProfileSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultProfileSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultProfileSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByUuid",
    findByField: "uuid",
    findByVariableName: "uuid",
    modelApiIdentifier,
    defaultSelection: DefaultProfileSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByUuid",
    findByField: "uuid",
    findByVariableName: "uuid",
    modelApiIdentifier,
    defaultSelection: DefaultProfileSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByPublicSlug",
    findByField: "publicSlug",
    findByVariableName: "publicSlug",
    modelApiIdentifier,
    defaultSelection: DefaultProfileSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByPublicSlug",
    findByField: "publicSlug",
    findByVariableName: "publicSlug",
    modelApiIdentifier,
    defaultSelection: DefaultProfileSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByReferralCode",
    findByField: "referralCode",
    findByVariableName: "referralCode",
    modelApiIdentifier,
    defaultSelection: DefaultProfileSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByReferralCode",
    findByField: "referralCode",
    findByVariableName: "referralCode",
    modelApiIdentifier,
    defaultSelection: DefaultProfileSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByBookingShareToken",
    findByField: "bookingShareToken",
    findByVariableName: "bookingShareToken",
    modelApiIdentifier,
    defaultSelection: DefaultProfileSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByBookingShareToken",
    findByField: "bookingShareToken",
    findByVariableName: "bookingShareToken",
    modelApiIdentifier,
    defaultSelection: DefaultProfileSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createProfile",
    operationReturnType: "CreateProfile",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: { profile: { required: false, type: "CreateProfileInput" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultProfileSelection
  },
  {
    type: "action",
    operationName: "bulkCreateProfiles",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkCreateProfilesInput!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultProfileSelection
  },
  {
    type: "action",
    operationName: "updateProfile",
    operationReturnType: "UpdateProfile",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      profile: { required: false, type: "UpdateProfileInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultProfileSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateProfiles",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkUpdateProfilesInput!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultProfileSelection
  },
  {
    type: "action",
    operationName: "deleteProfile",
    operationReturnType: "DeleteProfile",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteProfiles",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "generateReferralCodeProfile",
    operationReturnType: "GenerateReferralCodeProfile",
    functionName: "generateReferralCode",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      profile: { required: false, type: "GenerateReferralCodeProfileInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: true,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultProfileSelection
  },
  {
    type: "action",
    operationName: "bulkGenerateReferralCodeProfiles",
    functionName: "bulkGenerateReferralCode",
    isBulk: true,
    isDeleter: false,
    hasReturnType: true,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "generateReferralCode",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkGenerateReferralCodeProfilesInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultProfileSelection
  },
  {
    type: "action",
    operationName: "initPipelineProfile",
    operationReturnType: "InitPipelineProfile",
    functionName: "initPipeline",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      profile: { required: false, type: "InitPipelineProfileInput" },
      tradeType: { required: false, type: "String" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["tradeType"],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultProfileSelection
  },
  {
    type: "action",
    operationName: "bulkInitPipelineProfiles",
    functionName: "bulkInitPipeline",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "initPipeline",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkInitPipelineProfilesInput!]" }
    },
    paramOnlyVariables: ["tradeType"],
    defaultSelection: DefaultProfileSelection
  },
  {
    type: "action",
    operationName: "upsertProfile",
    operationReturnType: "UpsertProfile",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      profile: { required: false, type: "UpsertProfileInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateProfileResult": { hasReturnType: false },
      "... on UpdateProfileResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultProfileSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertProfiles",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkUpsertProfilesInput!]" } },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultProfileSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "profileGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const ProfileManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultProfileSelection,
  operations
);
export {
  DefaultProfileSelection,
  ProfileManager
};
//# sourceMappingURL=Profile.js.map
